import ParallaxContainer from './ParallaxContainer';

export default ParallaxContainer;
